export const URL_BASE = "https://apim-devg.azure-api.net/portfolio";

export const URL_ADD_CONTACTME = `${URL_BASE}/contactform`;
